import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <>
      <Helmet>
        <title>Privaatsuspoliitika | Tõuks.ee</title>
        <meta name="description" content="Tõuks.ee privaatsuspoliitika. Tutvuge, kuidas me teie isikuandmeid kogume, kasutame ja kaitseme." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://xn--tuks-0qa.ee/privaatsustingimused" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Kodu", "item": "https://xn--tuks-0qa.ee/" },
            { "@type": "ListItem", "position": 2, "name": "Privaatsuspoliitika", "item": "https://xn--tuks-0qa.ee/privaatsustingimused" }
          ]
        })}</script>
      </Helmet>

      <div className="container mx-auto py-12 px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold mb-6">Privaatsuspoliitika</h1>

          <p className="mb-8 text-gray-600 leading-relaxed">
            Käesolev privaatsuspoliitika selgitab, kuidas <strong>Kvantis OÜ</strong> („meie") kogub, kasutab ja kaitseb sinu isikuandmeid külastades meie veebilehte tõuks.ee või sooritades ostu meie juures. Järgime Euroopa Liidu üldist andmekaitsemäärust (GDPR) ja Eesti kehtivaid andmekaitseseadusi.
          </p>

          {/* Kes me oleme */}
          <h2 className="text-2xl font-bold mt-10 mb-4">Kes me oleme</h2>
          <div className="bg-gray-50 rounded-xl p-6 space-y-2 text-gray-600 mb-8">
            <p><span className="font-medium">Ettevõte:</span> Kvantis OÜ</p>
            <p><span className="font-medium">Registrikood:</span> 17190909</p>
            <p><span className="font-medium">KMKR:</span> EE102837029</p>
            <p><span className="font-medium">Aadress:</span> Suislepa tn 2, Jõgeva, Eesti</p>
            <p>
              <span className="font-medium">E-post:</span>{' '}
              <a href="mailto:ametliktouks@gmail.com" className="text-[#4FC1E9] hover:underline">ametliktouks@gmail.com</a>
            </p>
          </div>

          {/* Õiguslik alus */}
          <h2 className="text-2xl font-bold mt-10 mb-4">Isikuandmete töötlemise õiguslik alus</h2>
          <p className="text-gray-600 mb-3">Töötleme isikuandmeid järgmistel õiguslikel alustel:</p>
          <ul className="list-disc pl-6 mb-8 space-y-2 text-gray-600">
            <li><strong>Lepingu täitmiseks</strong> — tellimuse töötlemine, kohaletoimetamine ja klienditoe pakkumine.</li>
            <li><strong>Õiguslike kohustuste täitmiseks</strong> — raamatupidamise, maksude ja tarbijakaitse nõuete täitmine.</li>
            <li><strong>Nõusoleku alusel</strong> — vabatahtlike tegevuste puhul, nagu uudiskirjaga liitumine.</li>
            <li><strong>Õigustatud huvi alusel</strong> — veebilehe turvalisuse tagamiseks ja teenuste arendamiseks.</li>
          </ul>

          {/* Mida kogume */}
          <h2 className="text-2xl font-bold mt-10 mb-4">Milliseid isikuandmeid me kogume ja miks</h2>
          <ul className="list-disc pl-6 mb-8 space-y-2 text-gray-600">
            <li><strong>Kontaktandmed</strong> (nimi, e-post) — tellimuste töötlemiseks ja suhtluseks.</li>
            <li><strong>Tarneaadress</strong> — toodete kohaletoimetamiseks valitud pakiautomaati.</li>
            <li><strong>Makseandmeid</strong> töötleb turvaliselt ESTO AS — meie ei salvesta pangakaardi ega pangatunnuste andmeid.</li>
            <li><strong>Tellimuste ajalugu ja kliendisuhtluse logid</strong> — klienditoe ja garantiiküsimuste lahendamiseks.</li>
            <li><strong>Tehnilised andmed</strong> (IP-aadress, seadme tüüp, brauseri info) — kogutakse Google Analyticsi kaudu jõudluse ja turvalisuse analüüsimiseks.</li>
          </ul>

          {/* Küpsised */}
          <h2 className="text-2xl font-bold mt-10 mb-4">Küpsised</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Meie veebileht kasutab küpsiseid ja sarnaseid tehnoloogiaid, et tagada lehe korrektne toimimine, parandada kasutajakogemust ja analüüsida liiklust. Küpsised on väikesed tekstifailid, mis salvestatakse sinu seadmesse veebilehte külastades.
          </p>
          <p className="text-gray-600 leading-relaxed mb-8">
            Kasutame nii vajalikke küpsiseid (veebilehe tööks hädavajalikud) kui ka valikulisi küpsiseid (analüütika jaoks). Saad küpsiseid hallata või kustutada oma brauseri seadetes, kuid arvestage, et mõne küpsise keelamine võib mõjutada veebilehe toimivust.
          </p>

          {/* Kolmandad osapooled */}
          <h2 className="text-2xl font-bold mt-10 mb-4">Kolmandate osapoolte teenused</h2>
          <ul className="list-disc pl-6 mb-8 space-y-2 text-gray-600">
            <li><strong>Maksed:</strong> Töötleb ESTO AS. Meie ei saa ligipääsu kliendi pangaandmetele.</li>
            <li><strong>Tarne:</strong> DPD, Omniva ja SmartPost saavad vajaliku tarneinfona sinu nime ja pakiautomaadi aadressi.</li>
            <li><strong>Analüütika:</strong> Google Analytics kogub anonüümset kasutusstatistikat, mis aitab parandada veebilehe jõudlust.</li>
          </ul>

          {/* Andmete säilitamine */}
          <h2 className="text-2xl font-bold mt-10 mb-4">Andmete säilitamine</h2>
          <p className="text-gray-600 mb-3">Säilitame andmeid ainult nii kaua, kui on vajalik eesmärkide täitmiseks või kui seadus seda nõuab:</p>
          <ul className="list-disc pl-6 mb-8 space-y-2 text-gray-600">
            <li><strong>Raamatupidamisandmeid</strong> säilitatakse 7 aastaks vastavalt Eesti raamatupidamiseeskirjadele.</li>
            <li><strong>Tellimus- ja kliendisuhtluse andmeid</strong> säilitatakse 3 aastaks pärast viimast kontakti, välja arvatud juhul, kui õiguslike küsimuste lahendamiseks on vaja pikemat tähtaega.</li>
          </ul>

          {/* Sinu õigused */}
          <h2 className="text-2xl font-bold mt-10 mb-4">Sinu andmekaitseõigused</h2>
          <p className="text-gray-600 mb-3">Sul on järgmised õigused seoses oma isikuandmetega:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-600">
            <li>Õigus tutvuda enda isikuandmetega.</li>
            <li>Õigus parandada ebatäpseid või puudulikke andmeid.</li>
            <li>Õigus taotleda andmete kustutamist, kui nende säilitamine ei ole enam vajalik.</li>
            <li>Õigus piirata või vaidlustada andmete töötlemist teatud juhtudel.</li>
            <li>Õigus andmete ülekantavusele (saada andmed struktureeritud, masinloetaval kujul).</li>
            <li>Õigus võtta tagasi nõusolek, kui töötlemine toimub nõusoleku alusel.</li>
          </ul>
          <p className="text-gray-600 leading-relaxed mb-8">
            Neid õigusi saad teostada, võttes meiega ühendust aadressil{' '}
            <a href="mailto:ametliktouks@gmail.com" className="text-[#4FC1E9] hover:underline">ametliktouks@gmail.com</a>.
            Vastame ühe kuu jooksul.
          </p>

          {/* Turvalisus */}
          <h2 className="text-2xl font-bold mt-10 mb-4">Andmete turvalisus</h2>
          <p className="text-gray-600 leading-relaxed mb-8">
            Kaitseme sinu isikuandmeid turvaliste serverite, krüpteeritud ühenduste (SSL) ja piiratud ligipääsuga. Jälgime oma süsteeme pidevalt, et vältida volitamata juurdepääsu, avalikustamist või väärkasutust.
          </p>

          {/* Kontakt ja kaebused */}
          <h2 className="text-2xl font-bold mt-10 mb-4">Kontakt ja kaebused</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Privaatsusega seotud küsimuste või murede korral võta meiega ühendust:{' '}
            <a href="mailto:ametliktouks@gmail.com" className="text-[#4FC1E9] hover:underline">ametliktouks@gmail.com</a>.
          </p>
          <p className="text-gray-600 leading-relaxed mb-8">
            Kui leiad, et sinu andmeid töödeldakse õigusvastaselt, võid pöörduda{' '}
            <a href="mailto:info@aki.ee" className="text-[#4FC1E9] hover:underline">Eesti Andmekaitse Inspektsiooni</a>{' '}
            poole (info@aki.ee).
          </p>

          <div className="border-t border-gray-100 pt-6 flex flex-col sm:flex-row justify-between gap-4 text-sm text-gray-500">
            <p>Jõustumiskuupäev: märts 2026</p>
            <Link to="/muugitingimused" className="text-[#4FC1E9] hover:underline">Vaata müügitingimusi →</Link>
          </div>
        </div>
      </div>
    </>
  );
}
